<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'

const openSupport = () => {
  window.open('https://t.me/magvi_bot', '_blank')
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
const openModal = () => {
  if (refModal.value !== null) {
    refModal.value.openModal()
  }
}
defineExpose({
  closeModal,
  openModal,
})

</script>

<template>
  <RModal
    name-modal="supportModal"
    ref="refModal"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="supportModalLabel"
      >
        Поддержка в Телеграм
      </h5>
    </template>
    <template #body>
      Специалисты ответят на ваши вопросы и примут идеи для улучшения программы.
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="openSupport"
      >
        Перейти
      </AButton>
    </template>
  </RModal>
</template>
